import { createTheme } from "@mui/material/styles";

//general colors
export const mainColor = "#212121";
export const lightColor = "#616161";
export const infoColor = "#D7D7D7";
export const infoColorContast = "#424242";
export const bgHeaders = "#fff";
export const bgSections = "#fff";
// export const linkColor = "#003F85";
export const linkColor = "#4877CE";
export const linkMenuHoverBg = "#F5F5F5";

//toast (alert) messages
export const informationBgColor = "#E2F6FC";
export const informationColor = "#18435E";
export const informationColorFocus = "#3683B2";

export const successBgColor = "#559E10";
export const successColor = "#fff";

export const warningBgColor = "#C16817";
export const warningColor = "#fff";

export const errorBgColor = "#CE3A36";
export const errorColor = "#CE3A36";
export const errorTextColor = "#fff";

//forms
export const inputBorder = "#C4C4C4";
export const bgForms = "#fff";
export const addFileBg = "#F0F0F0";

//buttons
export const btnContainedPrimaryBgColor = "#234182";
export const btnContainedPrimaryBgColorHover = "#162a54";
export const btnOutlinedPrimaryBgColor = "#fff";

//other
export const dragActive = "#BAD0FF";

//theme
export default createTheme({
  palette: {
    background: {
      default: "#E3E3E3",
    },
    primary: {
      main: mainColor,
      light: lightColor,
    },
    error: {
      main: errorBgColor,
    },
    info: {
      main: infoColor,
      contrastText: infoColorContast,
    },
  },
  components: {
    //buttons
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none !important",
          borderRadius: "calc(4 * var(--atom))",
          height: "calc(8 * var(--atom))",
          fontSize: "calc(3.6 * var(--atom))",
          fontWeight: "300",
          width: "100%",
          textTransform: "none",

          "&.small-btn": {
            fontSize: "calc(2.8 * var(--atom))",
            lineHeight: "calc(3.2 * var(--atom))",
            borderRadius: "calc(0.8 * var(--atom))",
            padding: "calc(1.4 * var(--atom)) calc(2.4 * var(--atom))",
            height: "auto",

            svg: {
              maxHeight: "calc(3.2 * var(--atom))",
            },
          },
        },
        containedPrimary: {
          background: btnContainedPrimaryBgColor,
          "&:hover": {
            background: btnContainedPrimaryBgColorHover,
          },
        },
        outlinedPrimary: {
          background: btnOutlinedPrimaryBgColor,
        },
        containedInfo: {
          background: infoColor,
          "&:hover": {
            color: bgHeaders,
          },
        },
      },
    },
    //autocomplete
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          ".MuiOutlinedInput-root": {
            borderRadius: "5px",
            "&:hover": {
              fieldset: {
                borderColor: "#4877CE",
              },
            },
            "&:focus": {
              fieldset: {
                borderColor: "#4877CE !important",
              },
            },
          },
        },
        listbox: {
          maxHeight: "calc(80 * var(--atom))",
        },
      },
    },
    //modals
    MuiDialog: {
      styleOverrides: {
        paper: {
          "&.small": {
            width: "100%",
            maxWidth: "calc(138 * var(--atom))",
          },
          "&.big": {
            width: "100%",
            maxWidth: "calc(158 * var(--atom))",
          },
          "&.large": {
            width: "100%",
            maxWidth: "calc(185.2 * var(--atom))",

            ".MuiDialogContent-root": {
              // background: bgForms,
              // padding: "calc(4 * var(--atom)) 0 0",
              padding: 0,
            },
          },
          "&.xxl": {
            width: "calc(244 * var(--atom))",
            maxWidth: "90%",
            maxHeight: "90vh",
          },
          "&.xxl2": {
            width: "calc(244 * var(--atom))",
            maxWidth: "90%",
            height: "90vh",
            maxHeight: "90vh",
          },
          "&.fullscreen": {
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "100%",
            margin: 0,
            borderRadius: 0,
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "calc(4.6 * var(--atom))",
          lineHeight: "calc(5.4 * var(--atom))",
          fontWeight: 300,
          padding: "calc(3 * var(--atom)) calc(4 * var(--atom))",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          paddingBottom: "20px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "calc(4 * var(--atom))",
          img: {
            maxWidth: "100%",
          },
          "&.img-wrapper": {
            maxWidth: "100%",
            position: "relative",
            display: "flex",
            justifyContent: "center",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '"Open Sans"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});
